const styles = {
  body: {
    backgroundColor: 'background.grey',
    '&.whitebg': {
      backgroundColor: 'white!important',
      // '& > .MuiBox-root': {
      //   backgroundColor: 'white!important',
      // },
    },
  },

}

export default styles
